import { CountryCode } from 'libphonenumber-js';

export const EXCLUDED_PHONE_COUNTRIES: readonly CountryCode[] = ['CN', 'BY', 'RU'];
export const FAVORITE_PHONE_COUNTRIES: readonly CountryCode[] = ['BE', 'NL', 'LU', 'FR'];
export const DEFAULT_PHONE_COUNTRY: CountryCode = 'BE';
